import HttpService from '../baseHttp';

// 拦截单列表
export const HttpGetInterceptList = (data = {}) => HttpService.get('/api/v2/interceptOrder/findByPage', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS });
export const HttpGetManageInterceptList = (data = {}) => HttpService.get('/api/v2/interceptOrder/findByAdminPage', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS });
// 拦截单详情
export const HttpGetInterceptDetail = (data = {}) => HttpService.get('/api/v2/interceptOrder/findOne', { params: data });